import React from 'react'
import Grid from '@material-ui/core/Grid'
import { useDispatch, useSelector } from 'react-redux'
import { selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import { makeStyles } from '@material-ui/styles'
import Box from '@material-ui/core/Box'
import { returnToMenu, selectNavigationProduct } from '../actions/digitalMenuActions'
import CardMedia from '@material-ui/core/CardMedia'
import NumberFormat from 'react-number-format'
import NavigationTabs from './NavigationTabs'
import Card from '@material-ui/core/Card'
import DigitalMenuScreen from './DigitalMenuScreen'

const useStyles = makeStyles((theme) => ({
  tabs: {
    marginTop: '20px',
    marginLeft: '0 10px',
    marginRight: '0 10px',
  },
  dataContent: {
    width: 'auto',
    marginTop: '20px',
    marginLeft: '20px',
    marginRight: '20px',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  spacer: {
    marginTop: '30px',
  },
  subCategoryTitle: {
    marginTop: '30px',
    textTransform: 'uppercase',
  },
  price: {
    marginTop: '20px',
    textTransform: 'uppercase',
  },
  productName: {
    color: '#808080'
  },
  productDescription: {
    color: '#888888'
  },
  productImageCard: {
    display: 'block',
    height: 140,
    width: 140
  },
  productImage: {
    height: '100%',
    width: '100%',
    objectFit: 'cover'
  },
  categorySeparator: {
    marginBottom: '30px',
    border: '1px solid #909090',
  },
  productSeparator: {
    marginTop: '20px',
    marginBottom: '20px',
    border: '1px solid #F2F2F2',
  }
}))


const NavigationDetails = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const storeCode = useSelector(loadMenuDataSelectors.getStoreCode)
  const navigation = useSelector(loadMenuDataSelectors.getNavigation(props.match.params[1]))

  const colors = useSelector(loadMenuDataSelectors.getColors)

  const handleBackButtonClick = () => {
    dispatch(returnToMenu(storeCode))
  }

  const handleProductClick = (product) => () => {
    dispatch(selectNavigationProduct(navigation, product, storeCode))
  }

  const renderProductList = (products) => {
    return products?.map(product => {
      return <Grid key={`product-${product.productCode}`} item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center" onClick={handleProductClick(product)}>
              <Grid item xs={7}>
                <Grid container>
                  <Grid item xs={12}>
                    <Box fontSize={24} className={classes.productName} fontWeight="fontWeightBold">
                      {product.menu.title}
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box fontSize={20} className={classes.productDescription}>
                      {product.menu.listDescription}
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      fontSize={22}
                      fontWeight="fontWeightBold"
                      className={classes.price}
                      style={{ color: colors.primary }}
                    >
                      <NumberFormat
                        value={product.price}
                        displayType={'text'}
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={2}
                        prefix={'R$'}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container>
                  <Grid item xs={12}>
                    {product.imgUrl &&
                    <Card
                      className={classes.productImageCard}
                    >
                      <CardMedia
                        className={classes.productImage}
                        image={product.imgUrl}
                        title={product.menu.title}
                      />
                    </Card>
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr className={classes.productSeparator}/>
          </Grid>
        </Grid>
      </Grid>
    })
  }

  return <DigitalMenuScreen error={!navigation} handleBackButtonClick={handleBackButtonClick} {...props}>
    <Grid item xs={12} className={classes.tabs}>
      <NavigationTabs  {...props} />
    </Grid>
    <Grid item xs={12}>
      <Grid container className={classes.dataContent}>
        {navigation?.products &&
        <Grid item className={classes.spacer}>
          <Grid container>
            {renderProductList(navigation.products)}
          </Grid>
        </Grid>
        }
        {
          navigation?.children?.map(subNavigation => {
              return <Grid item key={`subNavigation-${subNavigation.id}`} xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Box
                          fontSize={22}
                          className={classes.subCategoryTitle}
                          style={{ color: colors.primary }}
                        >
                          {subNavigation.title}
                        </Box>
                      </Grid>
                      <Grid item xs={9}>
                        <hr className={classes.categorySeparator}/>
                      </Grid>
                    </Grid>
                  </Grid>
                  {renderProductList(subNavigation.products)}
                </Grid>
              </Grid>
            }
          )
        }
      </Grid>
    </Grid>
  </DigitalMenuScreen>

}

export default NavigationDetails
